import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
      token: localStorage.getItem('token') || ''
    },
    mutations: {
      setToken(state, token) {
        state.token = token;
        localStorage.setItem('token', token); // Guardar en localStorage
      },
      logout(state) {
        state.token = ''; 
        localStorage.removeItem('token'); // Eliminar token de localStorage
      }
    },
    actions: {
      setToken({ commit }, token) {
        commit('setToken', token);
      },
      logout({ commit }) {
        commit('logout');
      }
    },
    getters: {
      isAuthenticated(state) {
        return !!state.token;
      }
    }
  });
  